import React, { useState } from 'react';
import { isEmpty } from 'ramda';
import { connect } from 'react-redux';
import { getName } from 'country-list';
import { array, func } from 'prop-types';
import ReactCountryFlag from 'react-country-flag';

import {
  DetailsWrapper,
  DetailsInfoWrapper,
  ContactsWrapper,
  ContactItem,
  DetailItem,
  DetailKey,
  DetailValue,
  DetailValueItem,
  CopyWrapper,
  EditButtonWrapper,
  EditButton,
  EditButtonText,
  NoInfo,
} from './styled-components';
import { modalNames, openModal } from '../../../../modals';
import { copyToClipboard } from '../../../../utils';
import { ROUTES } from '../../../../routes';
import { Link } from '../../../ui-helpers';
import { theme } from '../../../../styles';
import SvgIcon from '../../../svg-icon';


const ContactDetails = ({ contacts, openModal: openModalAction }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    _id, emails, phones, skype, country, linkedIn, company, positionAtCompany,
  } = contacts[activeIndex];

  return (
    <div onClick={e => e.stopPropagation()}>
      {contacts.length > 1 ?
        <ContactsWrapper className="wrapper-contacts-names">
          {contacts.map((item, index) =>
            (
              <ContactItem
                key={item._id}
                onClick={() => setActiveIndex(index)}
                className={index === activeIndex ? 'active' : ''}
              >
                {item.fullName}
              </ContactItem>
            ))
          }
        </ContactsWrapper> : ''}

      <DetailsWrapper>
        <DetailsInfoWrapper>
          {emails && !!emails.length && (
            <DetailItem>
              <DetailKey>E-mail{emails.length > 1 && 's'}:</DetailKey>
              <DetailValue>
                {emails.map((item, index) =>
                  (<DetailValueItem
                    // eslint-disable-next-line react/no-array-index-key
                    key={`email-${index}`}
                    onClick={e => copyToClipboard(item, e)}
                  >
                    {`${item}`}
                    <CopyWrapper>
                      <SvgIcon
                        type="copy"
                        color={theme.colors.lightDark}
                        isWithoutHover
                      />
                    </CopyWrapper>
                  </DetailValueItem>))
                }
              </DetailValue>
            </DetailItem>
          )}

          {phones && !!phones.length && (
            <DetailItem>
              <DetailKey>Phones:</DetailKey>
              <DetailValue>
                {phones.map((item, index) =>
                  (<DetailValueItem
                    // eslint-disable-next-line react/no-array-index-key
                    key={`phone-${index}`}
                    onClick={e => copyToClipboard(item, e)}
                  >
                    {`${item}`}
                    <CopyWrapper>
                      <SvgIcon
                        type="copy"
                        color={theme.colors.lightDark}
                        isWithoutHover
                      />
                    </CopyWrapper>
                  </DetailValueItem>))
                }
              </DetailValue>
            </DetailItem>
          )}

          {skype && (
            <DetailItem>
              <DetailKey>Skype:</DetailKey>
              <DetailValue>
                <DetailValueItem
                  onClick={e => copyToClipboard(skype, e)}
                >
                  {skype}
                  <CopyWrapper>
                    <SvgIcon
                      type="copy"
                      color={theme.colors.lightDark}
                      isWithoutHover
                    />
                  </CopyWrapper>
                </DetailValueItem>
              </DetailValue>
            </DetailItem>
          )}

          {linkedIn && (
            <DetailItem>
              <DetailKey>LinkedIn:</DetailKey>
              <DetailValue>
                <DetailValueItem>
                  <a
                    href={linkedIn}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {linkedIn}
                    <CopyWrapper
                      onClick={(e) => { e.preventDefault(); copyToClipboard(linkedIn, e); }}
                    >
                      <SvgIcon
                        type="copy"
                        color={theme.colors.lightDark}
                        isWithoutHover
                      />
                    </CopyWrapper>
                  </a>
                </DetailValueItem>
              </DetailValue>
            </DetailItem>)
          }

          {country && (
            <DetailItem>
              <DetailKey>Country:</DetailKey>
              <DetailValue>
                <ReactCountryFlag
                  style={{
                    objectFit: 'cover',
                    height: '17.5px',
                    width: '26.25px',
                    marginRight: '7px',
                  }}
                  svg
                  countryCode={country}
                />
                {getName(country)}
              </DetailValue>
            </DetailItem>
          )}

          {company && company.name && (
            <DetailItem>
              <DetailKey>Company:</DetailKey>
              <DetailValue>
                <Link
                  href={`${ROUTES.COMPANY}?id=${company._id}`}
                  target="_blank"
                >
                  {company.name}
                </Link>
              </DetailValue>
            </DetailItem>
          )}

          {positionAtCompany && (
            <DetailItem>
              <DetailKey>Position at company:</DetailKey>
              <DetailValue>{positionAtCompany}</DetailValue>
            </DetailItem>
          )}

          {(!emails || !emails.length) && (!phones || !phones.length) && !skype &&
          !country && !linkedIn && (!company || isEmpty(company)) && !positionAtCompany && (
            <NoInfo>No information provided...</NoInfo>
          )}
        </DetailsInfoWrapper>

        <EditButtonWrapper>
          <EditButton onClick={() => {
            openModalAction({
              name: modalNames.EDIT_CONTACT,
              payload: { contactId: _id },
              width: 530,
            });
          }}
          >
            <SvgIcon
              type="pencil"
              color={theme.colors.fontTangerine}
              fillOpacity={1}
              isWithoutHover
            />
            <EditButtonText>Edit contact</EditButtonText>
          </EditButton>
        </EditButtonWrapper>
      </DetailsWrapper>
    </div>
  );
};

ContactDetails.propTypes = {
  openModal: func.isRequired,
  contacts: array.isRequired,
};

export default connect(null, { openModal })(ContactDetails);



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-info/contact-details/index.js